import { render, staticRenderFns } from "./DownloadIcon.vue?vue&type=template&id=e8ee7fa8&scoped=true&"
import script from "./DownloadIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DownloadIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ee7fa8",
  null
  
)

export default component.exports